module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("2")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("W")])])])]), _vm._v("esley was valiantly trying not to throw up. He’d passed on a drive-through lunch in anticipation of the job that he’d spent hours working up his nerve for, and it was a good thing, too.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The severed head at his feet looked like a prop for a haunted house. The edges of the neck skin were black with dried blood and curled, like a macabre ruffle. Red and white strings of sinew dangled out of the gaping hole that had once connected the head to a torso. The head’s eyes were partially open, and the skin was dark in places, hinting of a beating the man had received before he’d taken his last breath. The sparse, dark hair was a matted mess, caked with dirt and blood.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("Wesley stood holding pliers, giving himself a pep talk. Mouse had ordered him to remove the head’s teeth, which would make it harder for the cops to identify the head if it was found. This wasn’t what Wesley’d had in mind when he’d agreed to go undercover in The Carver’s loan-shark organization in exchange for having charges of attempted body snatching downgraded to a misdemeanor and additional hours added to his community service. By offering his services to Mouse to help him collect on overdue ")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("accounts, he’d hoped to kill two birds with one stone—fulfill the D.A.’s demands while clearing his own debt to The Carver. When he’d balked at performing the grotesque act, Mouse had told him he had Wesley’s jacket with the dead man’s blood on it. Wesley believed him. When he’d tried to recover his confiscated jacket from Mouse’s trunk, he’d found a severed finger inside.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“Just do it,” Mouse yelled. He stood nearby eating a Big Mac and fries.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("They were on an abandoned construction site in east Atlanta where the city leaders’ overly optimistic projections of growth had led to lots of digging, followed by lots of reneging. The site was deserted, hemmed in by a few trees, but there were no people or houses within sight. Just baked dirt, tinged red with Georgia clay, as far as the eye could see.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“Have you done this before?” Wesley asked his companion.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“Oh, yeah. You get used to it.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Wesley gagged.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“You’re thinking about it too much, little man. Fucking do it already.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Wesley took a deep breath and lowered the safety glasses over his eyes. Then he knelt on the ground, averted his gaze and felt for the man’s mouth. The dead flesh was cold and pulpy and the head reeked, like a rancid piece of meat. Wesley groped until he found the mouth, then pried open the stiff lips. He glanced down and grew light-headed at the sight of his hands in the mouth of the disembodied head.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“Start with the front ones,” Mouse advised, chewing on his burger. “They snap off like dried corn.”")])])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Wes swallowed hard and positioned the pliers with a shaking hand around one of the big square front teeth. The stretching and pulling had made the man’s eyelids pop open, revealing his cloudy irises. Wesley squeezed the pliers, but when he pulled up, the head slid against the ground and spun out of his grasp, rolling like a melon.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mouse belly laughed, obviously enjoying the show.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Wesley wrestled the head back in position, then put it between his knees to hold it still. Panicky and sickened, he repositioned the pliers and pulled as hard as he could. Something pinged against his safety glasses, and when he looked down, half of the tooth was gone. Bile backed up in his throat, but before he could change his mind, he broke off the other half of the tooth and dropped it in the Micky D’s disposable cup that Mouse had conveniently provided.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“See, that wasn’t so hard,” Mouse urged him on.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("One by one, Wes rid the head of its teeth. Some of them broke off, and some of them came out root and all. There was no blood, thank God, but plenty of flying gum tissue to muck up the safety glasses. Mr. Dead Man had spent a lot of money on his choppers, because he had caps, and two in the back were gold.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ll take those,” Mouse said, extending a handkerchief for Wesley to drop them into.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What will you do with them?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sell them.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Who the heck buys gold teeth?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Well, most of our sources have dried up because it’s gotten too risky, but now those companies that buy gold through the mail make it real easy. They send me a postage-paid envelope, I drop in the gold teeth, and a couple of weeks later, I get a check, easy-peasy.”")])])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Wesley’s eyes bulged. “They don’t wonder where you got an envelope full of gold teeth?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He shrugged. “They don’t care. Ain’t America grand?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The molars and the wisdom teeth presented the greatest challenge, but by then, Wesley had gotten the hang of it and twisted them out like pulling stumps out of the ground. When he dropped the last tooth into the cup, he sat back on his heels and tore off the safety glasses. The head rolled a quarter turn, its mouth a snaggly hole. Wesley stumbled to his feet, walked to the nearest bush and threw up.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mouse chuckled, then picked up the cup of teeth and headed back to the Town Car. “When you’re finished, let’s go.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Wes wiped his mouth with his sleeve. “What about the head?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Leave it. It’s supposed to be a hundred degrees today—the bugs and the birds will take care of it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What about the skull?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hell, if someone does find it, they’ll probably take it home and put it on their bookshelf.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Wesley walked back to the car to put the tools and gloves in a bucket in the trunk. He stopped for a moment and let the reality of what he’d done wash over him, then he slammed down the lid with revulsion.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hey, take it easy,” Mouse called. “Get in.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Wes crawled into the front seat, hot and sweaty, the stink of rotting flesh in his nostrils.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Moist towelette?” Mouse asked, extending one of those little foil packets that barbecue joints pass out to customers.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("He took it and tore it open, then unfolded the disposable towel and held it against his face, breathing in the antisep")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("tic smell. God, that was the worst thing he’d ever done. He had a feeling he’d be having nightmares about it for a while. He needed a hit of Oxy, bad. He reached for his backpack just as his phone rang from inside. Wes pulled it out and frowned. The screen said he had eight messages and the incoming call was from Carlotta—something was wrong.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', [_vm._v("“I need to get this,” he said to Mouse, then flipped up the phone. “Yeah?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', [_vm._v("“Wes, where are you? I’ve left you a half-dozen messages.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', [_vm._v("“Um, I’ve been working. Is something wrong, sis?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', [_vm._v("He listened with incredulity as she told him how she’d discovered that Michael Lane had been living in their parents’ bedroom. He shook his head, his mind racing at the implication—the psycho had been roaming around their house at all hours, doing chores? “That’s crazy. For how long?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', [_vm._v("“We think since Friday.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', [_vm._v("“Jesus Christ, why aren’t we dead?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', [_vm._v("“Good question. Michael obviously had ample opportunity to do whatever he wanted.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', [_vm._v("He hated hearing the fear in his sister’s voice. “They don’t know where Lane is?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', [_vm._v("“Not yet. But at least Jack knows he’s on the run again, so they have an APB out on him.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', [_vm._v("“I’m going to install a security system in the town house,” he said. Guilt tightened his chest. He should’ve done it before now, considering all the trouble the pair had been in lately. He wasn’t doing a very good job of taking care of his sister after years of her taking care of him.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', [_vm._v("“I think that’s a good idea. But meanwhile, Peter invited me to stay at his house until the dust settles.”")])])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He frowned. “You’re moving in with Peter?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m staying at his house,” she corrected. “And Jack is having a CSI team go over the town house, so you should come, too. Peter has plenty of room.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He remembered the man’s huge home from when he and Coop had gone there to remove the body of Peter’s wife after she’d drowned in the pool. “Thanks, but I’ll probably crash with Chance.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Okay,” she said, although he could feel her disapproval vibrating over the line. Carlotta didn’t like his buddy Chance Hollander—she thought Chance was a bad influence on him. Little did she know that he’d just performed oral surgery on a severed head while Chance was probably watching cartoons.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Wes, there’s something else. It looks like Michael stole your money before he left.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His stomach fell. “No…no…. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("no.")])]), _vm._v(" Are you sure?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I didn’t touch it, so if it’s gone, that only leaves Michael.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He leaned his head back and groaned.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m sorry, I know you had plans for that money. But in the scheme of things, we’re lucky to be alive.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yeah, I know. But still.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So, how’s the courier job going?” she asked cheerfully.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He glanced down at the cup of teeth in the console and his intestines cramped. “Fine and dandy.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Good. I’ll have my cell phone with me, and here’s the number at Peter’s.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Okay,” he said, taking down the information. “Later.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He disconnected the call and sighed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Trouble at home?” Mouse asked.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("“You know it.” Now he "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("really")])]), _vm._v(" needed a hit of Oxy. ")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Reaching into his backpack, he palmed a pill into his mouth and chewed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“What’s that?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“What’s what?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“Whatever you just put in your mouth, smart-ass.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("Wesley frowned. “What do you care?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“Didn’t take you for a druggie,” Mouse said, looking almost disappointed.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“Don’t sweat it, man. It’s just something to take the edge off.” He wrapped his fingers around the section of his arm where The Carver had lived up to his nickname by etching the first three letters of his name into Wesley’s forearm after Wesley had humiliated The Carver in a stunt at a strip club. “My arm still hurts, dude.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“Maybe so, but drugs’ll mess you up.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("Wesley lifted an eyebrow. “That’s rich coming from you.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“I’m just saying, little man, watch yourself.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("The cool pleasure of the Oxy coursed through his system, making the day’s events a rosy haze. Still, high or not, he realized that he needed cash, and Mouse wasn’t the kind of guy to pass out bonuses. “Are we through for the day?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“Yeah. I have to go to my niece’s dance recital. Where can I drop you?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“Not at the house—the police are there.” Wes lifted his hand. “Don’t ask, man, it’s a long story.” On impulse, he pulled out his phone and brought up Coop’s cell number. After a few rings, Coop answered.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“Hey, Wes, what’s up?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("He wet his lips, suddenly nervous to talk to the man he’d let down by conspiring to steal a body they’d been trans")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("porting. “I was wondering if you had any work for me tonight?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("The silence on the other end indicated that Coop wasn’t going to be easily persuaded to trust Wesley again. “I don’t know. We need to talk.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("“Okay, where are you?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("“At the morgue, working in the lab.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("“Can I come by?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("Coop sighed into the phone, then made a frustrated noise. “Uh, sure.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("“Great. See ya.” He closed the phone and glanced at Mouse. “Can you drop me at the morgue?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("Mouse nodded. “Sure.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("“Turn at the next street.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("Mouse laughed and put on his signal. “I know the way, little man. I know the way.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('span', [_vm._v("Wesley swallowed, picturing Mouse driving by the morgue and pitching out bodies like apple cores. He leaned his head back on the headrest. What had he gotten himself into?")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page28"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-675b295f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5bodiestodiefor_ch02.vue
// module id = 72
// module chunks = 0